import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDismissAlerts = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		strokeLinecap: "round",
		fill: "none",
		d: "m9.38419,5.68579a4.92645,4.92645 0 1 0 9.85289,0a4.92645,4.92645 0 1 0 -9.85289,0"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		strokeLinecap: "round",
		fill: "none",
		d: "m12.15942,6.09632l1.23161,1.23161l3.07903,-3.07902"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		strokeLinecap: "round",
		fill: "none",
		d: "m14.63085,13.60916a5.74752,5.74752 0 0 0 0.9114,1.92953l-14.77934,0s1.23161,-1.91311 1.23161,-6.77387a6.15806,6.15806 0 0 1 4.72118,-5.99384"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round",
		strokeLinecap: "round",
		fill: "none",
		d: "m6.51043,18.00191a1.70783,1.70783 0 0 0 3.28429,0"
	}));
});
export default SvgDismissAlerts;
